/* src/app/shared/invoice/headers/css.css */
span {
  display: inline-block;
}
/*# sourceMappingURL=css.css.map */
